import { getCookie } from '@/utils/auth'

const state = {
    showDelta: getCookie('showDelta')
}

const mutations = {
    SET_SHOW_DELTA: (state, showDelta) => {
        state.showDelta = showDelta
    },
}
const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}